<dx-data-grid
  #grid
  height="100%"
  [dataSource]="dso"
  [errorRowEnabled]="false"
  [stateStoring]="grid_stateStoring"
  (onInitialized)="grid_onInitialized($event)"
  (onToolbarPreparing)="grid_onToolbarPreparing($event)"
  (onEditingStart)="grid_onEditingStart($event)"
  (onSelectionChanged)="grid_onSelectionChanged($event)">
  <dxo-group-panel [visible]="true"></dxo-group-panel>

  <dxo-editing mode="form" [allowAdding]="false" [allowUpdating]="true" [allowDeleting]="true"></dxo-editing>

  <dxo-paging [pageSize]="config.get('itemsPerPage', 50)"></dxo-paging>

  <dxo-export [enabled]="true" fileName="vehicles-service-export"></dxo-export>

  <!-- Columns -->
  <dxi-column caption="Vehicle" dataField="vehicle.name" dataType="string"> </dxi-column>
  <dxi-column caption="Miles" dataField="miles" dataType="number"></dxi-column>
  <dxi-column caption="Mechanics Shop" dataField="mechanicsShop.name" dataType="string"> </dxi-column>
  <dxi-column caption="Date/Time In" dataField="dateTimeIn" dataType="date" format="shortDateShortTime"></dxi-column>
  <dxi-column caption="Date/Time Out" dataField="dateTimeOut" dataType="date" format="shortDateShortTime"></dxi-column>
  <dxi-column caption="Fleet Manager Assigned" dataField="fleetManagerAssigned.name" dataType="string"> </dxi-column>
  <dxi-column caption="Mechanic Assigned" dataField="mechanicAssigned.name" dataType="string"> </dxi-column>
  <dxi-column
    caption="Created At"
    dataField="createdAt"
    dataType="date"
    format="shortDateShortTime"
    [allowEditing]="false"
    sortOrder="desc"></dxi-column>
</dx-data-grid>

<!-- Templates -->
